// On page load, apply firmness metafield defaults and restore the last selected size from localStorage.
document.addEventListener('DOMContentLoaded', () => {
  const variantSelect = document.querySelector('select[id*="Size-"]');
  const sizeRadios = document.querySelectorAll('input[type="radio"][name*="Size-"]');
  const firmnessFieldset = document.querySelector('fieldset[data-default-firmness]');
  const firmnessSelect = document.querySelector('select.variant-option__select[name="options[Firmness]"]');
  const localSelectedValue = localStorage.getItem('sticky-sizing-selected-value');
  const url = new URL(window.location.href);
  const hasUrlVariantSelection = url.searchParams.has('variant') || url.searchParams.has('option_values');

  // Resolve firmness default from button-style fieldset first, then dropdown select.
  let firmnessDefault = null;
  if (firmnessFieldset instanceof HTMLFieldSetElement) {
    firmnessDefault = firmnessFieldset.getAttribute('data-default-firmness');
  }
  if (!firmnessDefault && firmnessSelect instanceof HTMLSelectElement) {
    firmnessDefault = firmnessSelect.getAttribute('data-default-firmness');
  }

  // Apply metafield firmness default unless the URL already specifies a variant.
  if (firmnessDefault && !hasUrlVariantSelection) {
    const firmnessRadio = document.querySelector(
      `input[type="radio"][name^="Firmness-"][value="${CSS.escape(firmnessDefault)}"]`
    );

    // Button-style picker: check the matching radio and sync variant state via change.
    if (firmnessRadio instanceof HTMLInputElement) {
      firmnessRadio.checked = true;
      firmnessRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Dropdown-style picker: only when no radio group exists on this product.
    if (!(firmnessRadio instanceof HTMLInputElement) && firmnessSelect instanceof HTMLSelectElement) {
      firmnessSelect.value = firmnessDefault;
      firmnessSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Size rendered as radio buttons.
  if (sizeRadios.length > 0) {
    // Persist size selection on every change for cross-page sticky sizing.
    sizeRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        localStorage.setItem('sticky-sizing-selected-value', radio.value);
      });
    });

    // Restore saved size on load; skip when URL variant params are present.
    if (localSelectedValue && !hasUrlVariantSelection) {
      const localSelectedOption = document.querySelector(
        `input[type="radio"][name*="Size-"][value="${localSelectedValue}"]`
      );

      // Saved size not available on this product (e.g. different option values).
      if (!localSelectedOption) {
        return;
      }

      localSelectedOption.checked = true;
      localSelectedOption.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Size rendered as a select — no further setup without it.
  if (!(variantSelect instanceof HTMLSelectElement)) {
    return;
  }

  // Restore saved size on load; skip when URL variant params are present.
  if (localSelectedValue && !hasUrlVariantSelection) {
    const localSelectedOption = variantSelect.querySelector(`option[value="${localSelectedValue}"]`);

    // Saved size not available on this product (e.g. different option values).
    if (!localSelectedOption) {
      return;
    }

    variantSelect.value = localSelectedValue;
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Persist size selection on every change for cross-page sticky sizing.
  variantSelect.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLSelectElement)) return;

    const selectedValue = event.target.value;

    if (!selectedValue || typeof selectedValue !== 'string') {
      return;
    }

    localStorage.setItem('sticky-sizing-selected-value', selectedValue);
  });
});
